module.exports = {
      id: "gzsports-usage",
      viewBox: "0 0 17.95 23.898",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#gzsports",
      toString: function () {
        return this.url;
      }
    }